import { Injectable } from '@angular/core';
import { KeyValueStorageInterface } from 'aws-amplify/utils';

export class CustomStorage implements KeyValueStorageInterface {
  
  private readonly REMEMBER_ME_KEY = 'rememberMe';

  private getStorage(): Storage {
    const rememberMe = localStorage.getItem(this.REMEMBER_ME_KEY) === 'true';
    return rememberMe ? localStorage : sessionStorage;
  }

  async setItem(key: string, value: string): Promise<void> {
    const storage = this.getStorage();
    storage.setItem(key, value);
  }

  async getItem(key: string): Promise<string | null> {
    return localStorage.getItem(key) || sessionStorage.getItem(key);
  }

  async removeItem(key: string): Promise<void> {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  async clear(): Promise<void> {

    const amplifyKeys = ['CognitoIdentityServiceProvider', 'aws-amplify'];
    
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && amplifyKeys.some(prefix => key.startsWith(prefix))) {
        localStorage.removeItem(key);
      }
    }
    
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (key && amplifyKeys.some(prefix => key.startsWith(prefix))) {
        sessionStorage.removeItem(key);
      }
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  
  private readonly REMEMBER_ME_KEY = 'rememberMe';

  setRememberMe(remember: boolean): void {
    localStorage.setItem(this.REMEMBER_ME_KEY, String(remember));    
    if (!remember) {
      this.migrateTokensToSessionStorage();
    }
  }

  getRememberMe(): boolean {
    return localStorage.getItem(this.REMEMBER_ME_KEY) === 'true';
  }

  private migrateTokensToSessionStorage(): void {

    const keysToMigrate: string[] = [];
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.includes('CognitoIdentityServiceProvider')) {
        keysToMigrate.push(key);
      }
    }
    
    keysToMigrate.forEach(key => {
      const value = localStorage.getItem(key);
      if (value) {
        sessionStorage.setItem(key, value);
        localStorage.removeItem(key);
      }
    });

  }

}